import {NgModule, Pipe, PipeTransform} from '@angular/core';
import {formatDate} from "@angular/common";

@Pipe({
    name: 'dateFormat',
    standalone: false
})
export class DateFormatPipe implements PipeTransform {

    transform(date: any, format: string): any {
        if(!date || !format){
            return '';
        }
        switch (format) {
            case "YYYY":
                return formatDate(new Date(date), 'yyyy', 'en_US');
            case "MM":
                return  formatDate(new Date(date), 'MM', 'en_US');
            case "MM/YYYY":
                return  formatDate(new Date(date), 'MM/yyyy', 'en_US');
            case "MM-YYYY":
                return  formatDate(new Date(date), 'MM-yyyy', 'en_US');
            case "DD/MM/YYYY":
                return formatDate(new Date(date), 'dd/MM/yyyy', 'en_US');
            default :
                return date;
        }
    }
}

@NgModule({
    declarations: [DateFormatPipe],
    exports: [DateFormatPipe],
})
export class DateFormatPipeModule {}
